import { sanitizeVisibilityValue, setVisitorRegion } from './modules/utils';

const selectors = {
	demo: '.mp-demo',
	page: '.mp-demo__page',
	backBtn: 'button#demo-back',
	nextBtn: 'button#demo-next',
	filter: '.mcfly-options',
	calendlyForm: '.mp-calendly',
};

const classNames = {
	pageOpen: 'open',
};

const stateUpdateEvent = 'demoStateUpdate';

const showComponent = async (el) => {
	await setVisitorRegion();

	const vRegion = localStorage.getItem('visitorRegion');
	const vCountry = localStorage.getItem('visitorCountry');

	let show = false;

	const targetRegions = el.getAttribute('data-regions') ? sanitizeVisibilityValue(el.getAttribute('data-regions')) : [];
	const excludedCountries = el.getAttribute('data-excluded-countries') ? sanitizeVisibilityValue(el.getAttribute('data-excluded-countries')) : [];
	const targetCountries = el.getAttribute('data-countries') ? sanitizeVisibilityValue(el.getAttribute('data-countries')) : [];

	if (targetRegions.length) {
		// The form should be visible for visitors from one or multiple regions
		if (targetRegions.includes(vRegion) && !excludedCountries.includes(vCountry)) {
			show = true;
		}
	} else if (targetCountries.length) {
		// The form should be visible for visitors from one or multiple countries
		if (targetCountries.includes(vCountry)) {
			show = true;
		}
	} else {
		// The form should be visible for every visitor
		show = true;
	}

	return show;
};

document.querySelectorAll(selectors.demo).forEach(async (demo) => {
	if (await showComponent(demo)) {
		// Show.
		demo.hidden = false;

		const filter = demo.querySelector(selectors.filter);
		const nextBtn = demo.querySelector(selectors.nextBtn);
		const backBtn = demo.querySelector(selectors.backBtn);

		const state = {
			page: 1,
			totalPages: demo.querySelectorAll(selectors.page).length,
			option: {},
		};

		const updateFilterState = () => {
			const filterValue = filter.getAttribute('data-value');
			if (filterValue) {
				const [accountID, eventID] = filterValue.split('|');
				state.option = {
					accountID,
					eventID,
				};
			}
		};

		const handleNavigationVisibility = () => {
			backBtn.hidden = 1 === state.page;
			nextBtn.hidden = state.page === state.totalPages;

			// Check if the user is allowed to continue.
			const activeOption = demo.querySelector(selectors.filter).getAttribute('data-value');
			nextBtn.disabled = activeOption === '';
		};

		const updatePageContent = () => {
			// Show / Hide Calendly form(s).
			if (2 === state.page) {
				demo.querySelectorAll(selectors.calendlyForm).forEach((form) => {
					const matchAccountID = form.getAttribute('data-account-link') === state.option.accountID;
					const matchEventID = form.getAttribute('data-event-link') === state.option.eventID;
					form.hidden = !(matchAccountID && matchEventID);
				});
			}

			// Open new page.
			const openPage = demo.querySelector(`${selectors.page}.${classNames.pageOpen}`);
			const targetPage = demo.querySelector(`${selectors.page}:nth-of-type(${state.page})`);

			if (targetPage && targetPage !== openPage) {
				openPage.classList.remove(classNames.pageOpen);
				targetPage.classList.add(classNames.pageOpen);
			}
		};

		demo.addEventListener(stateUpdateEvent, () => {
			updateFilterState();
			updatePageContent();
			handleNavigationVisibility();
		});

		// Navigation.
		nextBtn.addEventListener('click', () => {
			state.page = state.page + 1;
			demo.dispatchEvent(new CustomEvent(stateUpdateEvent));
		});

		backBtn.addEventListener('click', () => {
			state.page = state.page - 1;
			demo.dispatchEvent(new CustomEvent(stateUpdateEvent));
		});

		// Options.
		filter.addEventListener('click', () => {
			demo.dispatchEvent(new CustomEvent(stateUpdateEvent));
		});

		// Initial check.
		demo.dispatchEvent(new CustomEvent(stateUpdateEvent));
	} else {
		demo.remove();
	}

	// Listen for color scheme changes
	document.addEventListener('colorModeChange', (e) => {
		demo.setAttribute('data-color-scheme', e.detail);
	});
});
